import api from './axios';
import type { Product } from '../types/product';

export interface CategoryProductsResponse {
  products: Product[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
  // Legacy fields for backward compatibility
  total?: number;
  page?: number;
  limit?: number;
  totalPages?: number;
}

export interface CategoryProductsParams {
  page?: number;
  limit?: number;
  categoryId: number;
  sortBy?: 'new' | 'popular' | 'price_low' | 'price_high';
  brandIds?: number[];
  categoryIds?: number[];
}

export interface ProductCountParams {
  brandIds?: number[];
  categoryIds?: number[];
}

export interface ProductCountResponse {
  count: number;
  categoryIds?: number[];
  brandIds?: number[];
}

export const categoryProductsApi = {
  getCategoryProducts: async (params: CategoryProductsParams): Promise<CategoryProductsResponse> => {
    try {
      const { page = 1, limit = Math.min(params.limit || 12, 12), categoryId, sortBy = 'new', brandIds, categoryIds } = params;
      
      // Build query params
      const queryParams: {
        page: number;
        limit: number;
        categoryId: number;
        sortBy: string;
        brandIds?: string;
        categoryIds?: string;
      } = {
        page,
        limit,
        categoryId,
        sortBy,
      };
      
      // Add brand filter if provided
      if (brandIds && brandIds.length > 0) {
        queryParams.brandIds = brandIds.join(',');
      }
      
      // Add category filter if provided (for subcategories)
      if (categoryIds && categoryIds.length > 0) {
        queryParams.categoryIds = categoryIds.join(',');
      }
      
      const response = await api.get(`/api/shop/products`, {
        params: queryParams,
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching category products:', error);
      return {
        products: [],
        pagination: {
          page: 1,
          limit: 10,
          total: 0,
          totalPages: 0,
        },
        total: 0,
        page: 1,
        limit: 10,
        totalPages: 0,
      };
    }
  },

  getProductCount: async (params: ProductCountParams): Promise<ProductCountResponse> => {
    try {
      const queryParams: {
        brandIds?: string;
        categoryIds?: string;
      } = {};

      // Add brand filter if provided
      if (params.brandIds && params.brandIds.length > 0) {
        queryParams.brandIds = params.brandIds.join(',');
      }

      // Add category filter if provided
      if (params.categoryIds && params.categoryIds.length > 0) {
        queryParams.categoryIds = params.categoryIds.join(',');
      }

      const response = await api.get('/api/shop/products/count', {
        params: queryParams,
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching product count:', error);
      return {
        count: 0,
        brandIds: params.brandIds,
        categoryIds: params.categoryIds,
      };
    }
  },
};
